import { render, staticRenderFns } from "./ActivityBranch.vue?vue&type=template&id=317c0bf4&scoped=true"
import script from "./ActivityBranch.vue?vue&type=script&lang=js"
export * from "./ActivityBranch.vue?vue&type=script&lang=js"
import style0 from "./ActivityBranch.vue?vue&type=style&index=0&id=317c0bf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317c0bf4",
  null
  
)

export default component.exports